import { isWebGPUSupported } from './localEngine';

// System Orchestrator — decides whether a request can be handled on-device
// or needs to be routed to Lindey Private Cloud Compute.
const CLOUD_PATTERNS = [
  /\b(search|browse|look up|google|latest|news|current|today'?s|weather|stock|price of)\b/i,
  /\b(generate|create|draw|make)\b.{0,40}\b(image|picture|photo|logo|illustration)\b/i,
  /\b(write|debug|refactor|fix|implement|build)\b.{0,40}\b(code|function|script|program|app|api|class|component)\b/i,
  /```/,
  /\b(research|deep dive|comprehensive|essay|report|analyz\w+|proof|prove|derive|integrate|differential)\b/i,
  /https?:\/\//i,
];

export function routeQuery(content, { agentMode = false, hasFile = false, hasImage = false, mode = 'standard', gpuReady = null } = {}) {
  if (gpuReady === false || !isWebGPUSupported()) return { route: 'cloud', reason: 'no-webgpu' };
  if (agentMode) return { route: 'cloud', reason: 'agent' };
  if (hasFile || hasImage) return { route: 'cloud', reason: 'attachments' };
  if (mode === 'thinking') return { route: 'cloud', reason: 'thinking-mode' };
  const words = content.trim().split(/\s+/).length;
  if (words > 150) return { route: 'cloud', reason: 'long-prompt' };
  for (const p of CLOUD_PATTERNS) {
    if (p.test(content)) return { route: 'cloud', reason: 'complex' };
  }
  return { route: 'local', reason: 'on-device' };
}
